import Item from './item'

export default class PushItem extends Item {
  constructor (game, stack, playerPositionValue) {
    super(game, stack, 'item_push')

    this.playerPositionValue = playerPositionValue

    this.instructionName = 'PUSH'
    this.operands = []
  }

  _activate () {
    this.stack.push(this.playerPositionValue.get())
  }
}
